import React from "react";
import styled from "styled-components/native";
import { wpdColor } from "./src/styles/theme";
import {
  useFonts,
  Inter_300Light,
  Inter_400Regular,
  Inter_500Medium,
  Inter_600SemiBold,
  Inter_700Bold,
} from "@expo-google-fonts/inter";

import Routes from "./src/routing/Routes";

// Context
import { AuthProvider } from "./src/context/authContext";

const AppWrapper = styled.View`
  display: flex;
  background-color: ${wpdColor.background};
  flex-grow: 1;
`;

export default function App(): JSX.Element {
  const [fontsLoaded] = useFonts({
    Inter_300Light,
    Inter_400Regular,
    Inter_500Medium,
    Inter_600SemiBold,
    Inter_700Bold,
  });
  return (
    <AppWrapper>
      {fontsLoaded && (
        <AuthProvider>
          <Routes />
        </AuthProvider>
      )}
    </AppWrapper>
  );
}
